export const Experiment = {
  AshbyIntegration: "20230704_ASHBY_ATS_INTEGRATION",
  BooleanSearch: "20240626_HIRE_APP_BOOLEAN_SEARCH",
  DisableStartupEssential: "20260212_NO_SALES_STARTUP_ESSENTIAL",
  MessagingWarning: "20260330_HIRE_APP_MESSAGING_WARNING",
  MessagingDisabled: "20260330_HIRE_APP_MESSAGING_DISABLED",
} as const;
